var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.207 22.024a3.271 3.271 0 0 1-3.27-3.273 3.271 3.271 0 0 1 3.27-3.273 3.271 3.271 0 0 1 3.27 3.273 3.271 3.271 0 0 1-3.27 3.273zm.008-11.144c-4.661 0-7.444 2.917-7.444 7.801 0 2.78 3.69 9.202 7.442 14.33 3.73-5.145 7.446-11.488 7.446-14.33 0-4.884-2.783-7.8-7.444-7.8z",
    fill: "#F6B119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.457 35.79-1.242 1.633-1.235-1.632c-.91-1.19-8.861-11.816-8.861-17.11 0-6.35 3.96-10.455 10.096-10.455 6.135 0 10.095 4.104 10.095 10.455 0 5.286-7.952 15.913-8.853 17.11zm-1.242-34.2C10.499 1.59 1 11.098 1 22.826c0 11.727 9.498 21.234 21.214 21.234s21.214-9.507 21.214-21.234c0-11.728-9.498-21.234-21.214-21.234z",
    fill: "#FFF",
    stroke: "#ECECEC",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLocation);
export default __webpack_public_path__ + "static/media/search-location.64af3fddfc6e1a8675490d71149b918d.svg";
export { ForwardRef as ReactComponent };